export const truncateHash = (hash: string) =>
  `${hash.slice(0, 6)}...${hash.slice(-4)}`;
